import { render, staticRenderFns } from "./Backlogs.vue?vue&type=template&id=5b0baf42"
import script from "./Backlogs.vue?vue&type=script&lang=js"
export * from "./Backlogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports